import { BehaviorSubject } from "rxjs";
import { ChatBotService } from "../ChatBot/chat-bot.service";

export class RecordService {
  constructor(private _chatbot = new ChatBotService()) {}

  stream: MediaStream = {} as MediaStream;
  rec: MediaRecorder = {} as MediaRecorder;
  data: any[] = [];
  TIMER: number = 5000;
  static recording$ = new BehaviorSubject(false);
  static recording = this.recording$.asObservable();
  static setRecording(value): void {
    this.recording$.next(value);
  }

  async startStreaming(): Promise<void> {
    if (navigator.mediaDevices && navigator.mediaDevices.getUserMedia) {
      await navigator.mediaDevices
        .getUserMedia({ audio: true })
        .then((stream) => {
          if (stream) {
            this.stream = stream;
            this.recordStart();
          }
        })
        .catch((e) => {
          console.error(e);
        });
    } else {
      console.error("Could not get stream.");
    }
  }

  stopStreaming(): void {
    this.stream.getAudioTracks()[0].stop();
  }

  recordStart(): void {
    this.rec = new MediaRecorder(this.stream);
    this.data.length = 0;
    this.rec.start();
    RecordService.setRecording(true);
  }

  recordStop(): void {
    this.rec.stop();
    RecordService.setRecording(false);
  }

  sendAudioBuffer(encodeType: any): void {
    this.recordStop();
    this.rec.ondataavailable = (e) => {
      this.data.push(e.data);
    };
    this.rec.onstop = () => {
      new Blob(this.data).arrayBuffer().then((buffer) => {
        let encoder = new TextEncoder().encode(encodeType);
        let key = new Uint8Array(encoder.buffer);
        let a1 = new Uint8Array(encodeType ? [0x1, key.length] : [0x0]);
        let a2 = new Uint8Array(buffer);
        let concat = new Uint8Array(
          encodeType ? [...a1, ...key, ...a2] : [...a1, ...a2]
        );
        this._chatbot.sendBlobMessage(new Blob([concat.buffer]));
      });

      this.stopStreaming();
    };
  }

  sendActionWithRecord(encodeType?: any, timer?: number): void {
    this.startStreaming();
    setTimeout(() => {
      this.sendAudioBuffer(encodeType);
    }, timer);
  }
}
